export default {
    type6: { id: "choir", name: "Choir" }, 
    type5: { id: "conductor", name: "Conductor" }, 
    type15: { id: "ensemble", name: "Ensemble" },
    type1: { id: "featured_artist", name: "Featured Artist" },
    type4: { id: "orchestra", name: "Orchestra" },
    type2: { id: "remix_artist", name: "Remix Artist" }, 
    type3: { id: "versus_artist", name: "Versus Artist" }, 

    // type7: { id: "adaptor", name: "Adaptor" },
    // type8: { id: "administrator", name: "Administrator" },
    // type9: { id: "original_publisher", name: "Original Publisher" },
    // type10: { id: "sub_lyricist", name: "Sub Lyricist" },
    // type11: { id: "sub_adaptor", name: "Sub Adaptor" },
    // type12: { id: "sub_arranger", name: "Sub Arranger" },
    // type13: { id: "sub_publisher", name: "Sub Publisher" },

};
